import { Observable, ObservableArray } from "knockout";
import { EmojisPickerEmojiData } from "../interfaces/emojiData";
import EmojisPickerEmoji from "./emoji";

function toEmoji(item: any) {
    return new EmojisPickerEmoji({ title: item.n, unicode: item.c });
}

export interface EmojisPickerCategoryConfig {
    title: string
    icon: string
    emojis: Array<EmojisPickerEmojiData>
}

export default class EmojisPickerCategory {
    title: Observable<string>
    icon: Observable<string>
    emojis: ObservableArray<EmojisPickerEmoji>

    constructor(data: EmojisPickerCategoryConfig) {
        this.title = ko.observable(data.title);
        this.icon = ko.observable(data.icon);
        this.emojis = ko.observableArray(data.emojis.map(toEmoji));
    }
}